module.exports = __webpack_public_path__ + "static/media/mountain_unit_infiltration_example.d3a44863.jpg";